import { render, staticRenderFns } from "./Paragraphs.vue?vue&type=template&id=29ecce96&scoped=true&"
import script from "./Paragraphs.vue?vue&type=script&lang=js&"
export * from "./Paragraphs.vue?vue&type=script&lang=js&"
import style0 from "./Paragraphs.vue?vue&type=style&index=0&id=29ecce96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ecce96",
  null
  
)

export default component.exports